import Vue from 'vue';
import Router from 'vue-router';
import Header from './views/Header.vue';
import Sidebar from './views/Sidebar.vue';
import CtaButton from './views/CtaButton.vue';
import Alert from './views/Alert.vue';
import Index from './views/Index.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/alert',
      name: 'Alert',
      component: Alert,
    },
    {
      path: '/header',
      name: 'Header',
      component: Header,
    },
    {
      path: '/sidebar',
      name: 'Sidebar',
      component: Sidebar,
    },
    {
      path: '/CtaButton',
      name: 'CtaButton',
      component: CtaButton,
    },
  ],
});
